angular.module('offlineChecker')
    .controller('Search', Search);

Search.$inject = ['sessionFactory', 'storageFactory', 'uiManagerFactory', 'loginFactory', '$interval', '$scope', 'orderByFilter'];
function Search(sessionFactory, storageFactory, uiManagerFactory, loginFactory, $interval, $scope, orderByFilter) {
    var vm = this;
    vm.session = sessionFactory;
    vm.uiManager = uiManagerFactory;
    vm.uiManager.loader.isFullScreenLoading = false;
    vm.uiManager.lastUsed = moment();
    vm.uiManager.logoutable = true;
    vm.login = loginFactory;
    vm.storage = storageFactory;

    $interval.cancel(vm.uiManager.logoutPromise);
    vm.uiManager.logoutPromise = $interval(goBackToLogin, 10000);
    if(!vm.session.selectedProperty){
        vm.session.changingProperty = true;
    }

    // check user is allowed to view this page
    vm.uiManager.sendToLogin(vm.session.currentLogin);

    vm.clearFilterFirstName = function () {
        vm.session.searchFilters.bookingFName = '';
        resetLogoutCounter();
    };
    vm.clearFilterLastName = function () {
        vm.session.searchFilters.bookingLName = '';
        resetLogoutCounter();
    };
    vm.clearFilterBookingRef = function () {
        vm.session.searchFilters.bookingRef = '';
        resetLogoutCounter();
    };
    vm.clearFilterVehReg = function () {
        vm.session.searchFilters.vehReg = '';
        resetLogoutCounter();
    };
    vm.clearFilterUnitName = function () {
        vm.session.searchFilters.unitName = '';
        resetLogoutCounter();
    };
    vm.clearFilterRoomName = function () {
        vm.session.searchFilters.roomName = '';
        resetLogoutCounter();
    };
    vm.clearFilterRoomGuests = function () {
        vm.session.searchFilters.roomGuests = '';
        resetLogoutCounter();
    };
    vm.clearFilterArrivalDate = function () {
        vm.session.searchFilters.arrivalDate = '';
        resetLogoutCounter();
    };
    vm.clearFilterDepartureDate = function () {
        vm.session.searchFilters.departureDate = '';
        resetLogoutCounter();
    };
    vm.clearFilterCheckinStatus = function () {
        vm.session.searchFilters.checkinStatus = '';
        resetLogoutCounter();
    };
    vm.clearFilterReportingGroup = function () {
        vm.session.searchFilters.unitReportingGroup = '';
        resetLogoutCounter();
    };
    vm.minimiseSearchFiltersForm = function () {
        vm.session.searchForm.minimisedSearchFilters = true;
    };
    vm.maximiseSearchFiltersForm = function () {
        vm.session.searchForm.minimisedSearchFilters = false;
    };
    vm.toggleSearchFiltersForm = function () {
        vm.session.searchForm.minimisedSearchFilters = !vm.session.searchForm.minimisedSearchFilters;
    };
    vm.clearSearchFilters = function () {
        vm.clearFilterFirstName();
        vm.clearFilterLastName();
        vm.clearFilterBookingRef();
        vm.clearFilterVehReg();
        vm.clearFilterUnitName();
        vm.clearFilterRoomName();
        vm.clearFilterRoomGuests();
        vm.clearFilterArrivalDate();
        vm.clearFilterDepartureDate();
        vm.clearFilterCheckinStatus();
        vm.clearFilterReportingGroup();
    };
    // check the checking status for classing
    vm.getCheckinStatus = function (reservation) {
        var dateCheckIn = vm.getVal('dateCheckIn', reservation);
        var dateCheckOut = vm.getVal('dateCheckOut', reservation);
        var dateOut = vm.getVal('dateOut', reservation);
        var statusClass = '';
        if (dateCheckIn && !dateCheckOut) {
            if (moment(dateOut).startOf('day').isAfter(moment().startOf('day'))) {
                statusClass = 'checked-in';
            } else {
                statusClass = 'not-checked-out'
            }
        } else if (!dateCheckIn && !dateCheckOut) {
            statusClass = 'pending-checkin';
        } else {
            statusClass = 'checked-out';
        }
        return statusClass;
    };

    vm.resync = function () {
        vm.uiManager.loader.isFullScreenLoading = true;
        vm.login.sync(function (data) {
            vm.session.savedKeys = data.data.keys;
            vm.session.savedReservations = data.data.data;
            vm.session.userAttachedAccount = data.data.user.pid;
            vm.session.name = data.data.user.firstName + ' ' + data.data.user.lastName;
            vm.session.savedProperties = data.data.properties;
            vm.session.savedUnitReportGroups = data.data.unitReportGroups;
            vm.session.lastSynced = moment().toDate();
            // save the records
            vm.storage.userToken.set(data.data.token, vm.session.currentLogin.pin);
            vm.storage.reservations.set(vm.session.savedReservations, vm.session.currentLogin.pin);
            vm.storage.keys.set(vm.session.savedKeys, vm.session.currentLogin.pin);
            vm.storage.properties.set(vm.session.savedProperties, vm.session.currentLogin.pin);
            vm.storage.savedUnitReportGroups.set(vm.session.savedUnitReportGroups, vm.session.currentLogin.pin);
            vm.storage.lastSynced.set(vm.session.lastSynced, vm.session.currentLogin.pin);
            vm.session.changingProperty = false;
            // resort the reservations
            vm.sortReservations(vm.sortByUnitType);
            vm.uiManager.loader.isFullScreenLoading = false;
        }, function () {
            // sync failed
            vm.uiManager.loader.isFullScreenLoading = false;
        })
    };

    vm.getVal = function (val, extra) {
        // loop through the values in the keys and retrieve this data
        var place = vm.session.savedKeys.indexOf(val);
        if (place >= 0) {
            if (extra.length > place) {
                return extra[place];
            } else {
                return null; // extra doesn't have the keys index in it
            }
        } else {
            return null; // key doesn't exist
        }
    };
    vm.getFieldIndex = function (key) {
        var index;
        if (Array.isArray(vm.session.savedKeys)) {
            index = vm.session.savedKeys.indexOf(key);
        }
        return index;
    };
    vm.getFormattedDate = function (date) {
        return moment(date).format('Do MMM, YYYY');
    };
    vm.getFormattedTime = function (date) {
        return moment(date).format('h:mm a');
    };
    vm.getFormattedTimeWithSeconds = function (date) {
        return moment(date).format('h:mm:ss a');
    };
    vm.getAge = function (dob) {
        return moment().diff(moment(dob), 'years');
    };

    vm.session.searchFilters.sortReservations = 'unitTypeOrderAsc';

    vm.sortReservations = function () {
        vm.session.sortAscending = false;
        switch (vm.session.searchFilters.sortReservations) {
            case 'unitOrderAsc':
                vm.session.sortAscending = true;
            case 'unitOrderDesc':
                vm.session.savedReservations.sort(vm.sortByUnit);
                break;
            case 'arrivalDateAsc':
                vm.session.sortAscending = true;
            case 'arrivalDateDesc':
                vm.session.savedReservations.sort(vm.sortByArrivalDate);
                break;
            case 'departureDateAsc':
                vm.session.sortAscending = true;
            case 'departureDateDesc':
                vm.session.savedReservations.sort(vm.sortByDepartureDate);
                break;
            case 'unitTypeOrderAsc':
                vm.session.sortAscending = true;
            default:
                vm.session.savedReservations.sort(vm.sortByUnitType);
                break;
        }
    };

    function goBackToLogin() {
        if ((moment().subtract(vm.uiManager.logoutCount, 'seconds') > vm.uiManager.lastUsed) && vm.uiManager.logoutable) {
            vm.uiManager.goToPage('/login');
        }
    }

    function resetLogoutCounter() {
        vm.uiManager.lastUsed = moment();
    }

    vm.sortByUnitType = function (v1, v2) {
        // get the index of the type
        var unitTypeOrderIndex = vm.getFieldIndex('unitTypeOrder');
        // get the index of the unit
        var unitOrderIndex = vm.getFieldIndex('display_order');
        // ge thte index of the arrival date
        var arrivalIndex = vm.getFieldIndex('dateIn');

        var v1UnitTypeOrder = v1[unitTypeOrderIndex];
        var v2UnitTypeOrder = v2[unitTypeOrderIndex];
        var v1UnitOrder = v1[unitOrderIndex];
        var v2UnitOrder = v2[unitOrderIndex];
        var v1Arrival = moment(v1[arrivalIndex]);
        var v2Arrival = moment(v2[arrivalIndex]);

        if (v1UnitTypeOrder === null && v2UnitTypeOrder !== null) {
            return 1;
        }

        if (v2UnitTypeOrder === null && v1UnitTypeOrder !== null) {
            return -1;
        }

        if (v1UnitTypeOrder === v2UnitTypeOrder) {
            if (v1UnitOrder === null && v2UnitOrder !== null) {
                return 1;
            }

            if (v2UnitOrder === null && v1UnitOrder !== null) {
                return -1;
            }

            if (v2UnitOrder === null && v1UnitOrder === null) {
                return 0;
            }

            if(v1UnitOrder === v2UnitOrder){
                return v1Arrival.isBefore(v2Arrival) ? -1 : 1;
            }

            return v1UnitOrder - v2UnitOrder;
        } else {
            return vm.session.sortAscending ? (v1UnitTypeOrder - v2UnitTypeOrder) : (v2UnitTypeOrder - v1UnitTypeOrder);
        }
    };

    vm.sortByUnit = function (v1, v2) {
        var displayIndex = vm.getFieldIndex('display_order');
        var arrivalIndex = vm.getFieldIndex('dateIn');
        var v1DisplayOrder = v1[displayIndex];
        var v1Arrival = moment(v1[arrivalIndex]);
        var v2DisplayOrder = v2[displayIndex];
        var v2Arrival = moment(v2[arrivalIndex]);
        if (v1DisplayOrder === null) {
            return -1;
        }
        if (v2DisplayOrder === null) {
            return 1;
        }
        if(v1DisplayOrder === v2DisplayOrder){
            return (v1Arrival.isBefore(v2Arrival)) ? -1 : 1;
        }
        return vm.session.sortAscending ? (v1DisplayOrder - v2DisplayOrder) : (v2DisplayOrder - v1DisplayOrder);
    };

    vm.sortByArrivalDate = function (v1, v2) {
        var arrivalIndex = vm.getFieldIndex('dateIn');
        var v1Arrival = moment(v1[arrivalIndex]);
        var v2Arrival = moment(v2[arrivalIndex]);
        if (vm.session.sortAscending) {
            return (v1Arrival.isBefore(v2Arrival)) ? -1 : 1;
        } else {
            return (v1Arrival.isAfter(v2Arrival)) ? -1 : 1;
        }
    };

    vm.sortByDepartureDate = function (v1, v2) {
        var departureIndex = vm.getFieldIndex('dateOut');
        var v1Departure = moment(v1[departureIndex]);
        var v2Departure = moment(v2[departureIndex]);
        if (vm.session.sortAscending) {
            return (v1Departure.isBefore(v2Departure)) ? -1 : 1;
        } else {
            return (v1Departure.isAfter(v2Departure)) ? -1 : 1;
        }
    };

    vm.updateSelectedProperty = function () {
        // update the saved session and resync the data. if no resync then show an alert to the user.
        vm.session.previousProperty = vm.session.selectedProperty;
        vm.session.selectedProperty = vm.session.tempSelectedProperty;
        // call resync
        vm.uiManager.loader.isFullScreenLoading = true;

        vm.login.sync(function (data) {
            // save the selected property
            vm.storage.selectedProperty.set(vm.session.selectedProperty, vm.session.currentLogin.pin);

            vm.session.savedKeys = data.data.keys;
            vm.session.savedReservations = data.data.data;
            vm.session.userAttachedAccount = data.data.user.pid;
            vm.session.name = data.data.user.firstName + ' ' + data.data.user.lastName;
            vm.session.savedProperties = data.data.properties;
            vm.session.savedUnitReportGroups = data.data.unitReportGroups;
            vm.session.lastSynced = moment().toDate();
            // save the records
            vm.storage.userToken.set(data.data.token, vm.session.currentLogin.pin);
            vm.storage.reservations.set(vm.session.savedReservations, vm.session.currentLogin.pin);
            vm.storage.keys.set(vm.session.savedKeys, vm.session.currentLogin.pin);
            vm.storage.properties.set(vm.session.savedProperties, vm.session.currentLogin.pin);
            vm.storage.savedUnitReportGroups.set(vm.session.savedUnitReportGroups, vm.session.currentLogin.pin);
            vm.storage.lastSynced.set(vm.session.lastSynced, vm.session.currentLogin.pin);
            // resort the reservations
            vm.sortReservations(vm.sortByUnitType);
            vm.uiManager.loader.isFullScreenLoading = false;
            vm.session.changingProperty = false;
            vm.session.failedPropertyChange = false;
        }, function () {
            // failed
            vm.session.selectedProperty = vm.session.previousProperty;
            vm.uiManager.loader.isFullScreenLoading = false;
            vm.session.changingProperty = false;
            // show error alert to user
            vm.session.failedPropertyChange = true;
        });
    };

    vm.session.sortAscending = true;
    vm.session.savedReservations.sort(vm.sortByUnitType);

    $scope.$watch('search.session.timerCount', function (current, original) {
        vm.uiManager.lastUsed = moment();
    }, true);

}
